import { useQuery } from '@tanstack/react-query';
import { useAPIClient } from '@/hooks/useAPIClient';

export interface RebuildTask {
  task_id: string;
  status: 'pending' | 'running' | 'completed' | 'failed' | 'cancelled';
  progress: number;
  current_operation: string | null;
  operations_completed: number;
  operations_total: number;
  mode: string;
  started_at: string;
  completed_at?: string;
  error?: string;
  results?: Record<string, unknown>;
}

/**
 * Hook to poll VDB rebuild task status
 * Automatically polls every 1 second while task is active
 * Stops polling when task completes, fails, or is cancelled
 */
export const useRebuildProgress = (taskId: string | null) => {
  const apiClient = useAPIClient();

  return useQuery<RebuildTask>({
    queryKey: ['rebuild-task', taskId],
    queryFn: async () => {
      if (!taskId) throw new Error('No task ID');
      return apiClient.documents.getRebuildTaskStatus(taskId);
    },
    enabled: !!taskId,
    refetchInterval: (data) => {
      // Poll every 1 second while task is active
      // Stop polling when task completes/fails/cancels
      const activeStatuses = ['pending', 'running'];
      return data && activeStatuses.includes(data.status) ? 1000 : false;
    },
    retry: false,
  });
};
